/**
 * Component Entry
 *
 */

import SkipContent from './SkipContent'
export default SkipContent
export * from './SkipContent'
